<template>
  <section class="cms-client-rules" @click.self="clickHandle">
    <div class="rules-wrapper">
      <div class="rules-title-wrapper">
        <p class="rules-title">活动规则</p>
        <p @click="clickHandle" class="rules-close-icon" :style="`background-image: url('${baseUrl}static/imgs/close-btn.png')`"></p>
      </div>
      <div class="rules-content">
        <DocContent :compProps="compProps"></DocContent>
      </div>
    </div>
  </section>
</template>

<script>
import DocContent from './DocContent'
export default {
  components: {
    DocContent
  },
  data() {
    return {
      compProps: {}
    }
  },
  created() { // 复用DocContent组件 按照这个组件的规则匹配下
    this.compProps = {
      content: this.rules,
      backgroundColor: '#fff'
    }
  },
  props: {
    rules: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  methods: {
    clickHandle() {
      this.$emit('action', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.cms-client-rules {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  .rules-wrapper {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translate(0, -50%);
    transition: all 0.5s ease-in-out;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    opacity: 1;
    background-color: #fff;
    margin: 0 1rem;
    max-height: 70%;
    border-radius: 0.6rem;
    z-index: 9999;
  }
  .rules-title-wrapper {
    display: flex;
    padding: 15px;
    justify-content: space-between;
    align-items: center;
  }
  .rules-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .rules-content {
    margin-top: -10px;
  }
  .rules-close-icon {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 1.2rem;
    height: 1.2rem;
    display: inline-block;
    background-position: center;
  }
}
</style>
